export default {"src":"/_next/static/media/ncash.99d74dad.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};